<template>
  <v-container class="my-16 mx-auto">
    <h1>出展タイトル</h1>
    <LogoList />
    <CompanyList />
    <p class="ma-10 text-right">※企業50音順・敬称略</p>
    <CopyRight />
    <TopButton />
  </v-container>
</template>

<script>
  import CompanyList from "./ExCompany.vue";
  import LogoList from "./LogoList.vue";
  import TopButton from "./TopButton.vue";
  import CopyRight from "./CopyRight.vue";

  export default {
    name: "App",
    components: {
      CopyRight,
      LogoList,
      CompanyList,
      TopButton,
    },
  };
</script>
